import { styled } from 'styled-components';
import { SPAdviceItem, SPDialogItem } from '~/pages/components/styles/styles';
import { classic } from '~/themes/classic';

type IProps = {
  text: string;
  onClick?: () => void;
  $margin?: string;
  characterImg?: string;
  advice?: string;
};

type TProps = IProps;

export function QuestionItem({ text, $margin, characterImg, advice }: TProps) {
  return (
    <Container $margin={$margin}>
      {characterImg && (
        <SDivImg>
          <img src={characterImg} alt="personnage" />
        </SDivImg>
      )}
      <SDivContent>
        <SPDialogItem $fontWeight="700" $color="#009fc3">
          {text}
        </SPDialogItem>
        <SPAdviceItem>{advice}</SPAdviceItem>
      </SDivContent>
    </Container>
  );
}

const Container = styled.div<{ $margin?: string }>`
  align-items: center;
  background-color: ${classic.token?.colorBgContainer};
  border-bottom: solid 3px #009fc3;

  display: flex;
  margin: ${({ $margin }) => ($margin ? $margin : 0)};
  min-height: 150px;
  user-select: none;
  width: 100%;
  @media screen and (max-width: 415px) {
    min-height: 0px;
  }
  @media screen and (max-height: 600px) {
    min-height: 0px;
  }
`;

const SDivImg = styled.div`
  flex: 0 0 25%;
  height: 100%;
  position: relative;

  img {
    bottom: 0;
    left: 0;
    position: absolute;
    object-fit: contain;
    height: auto;
    width: 100%;
  }
`;

const SDivContent = styled.div`
  flex-grow: 1;
  padding: calc(0.7rem + 10px) 14px;
  @media screen and (max-height: 415px) {
    padding: calc(0.5rem + 6px) 5px 10px 5px;
  }
  @media screen and (min-height: 800px) {
    padding: calc(0.7rem + 10px) 24px;
  }
`;
